export default __webpack_public_path__ + "static/media/greenDot.292b72ce.svg";